module.exports = __webpack_public_path__ + "img/menu-2.55365e9f.svg";